import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivityMonitorService, AuthService, TickEvent } from '@backbase/identity-auth';
import { OAuthService } from 'angular-oauth2-oidc';
import { filter, map, share, take } from 'rxjs';
import { Observable } from 'rxjs';

@Component({
  selector: 'bb-activity-monitor',
  templateUrl: './activity-monitor.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivityMonitorComponent implements OnInit {
  private events$!: Observable<TickEvent | { type: string }>;
  private readonly openTypes = ['start', 'tick'];
  readonly isOpen$!: Observable<boolean>;
  readonly remaining$!: Observable<number>;

  constructor(
    private readonly activityMonitorService: ActivityMonitorService,
    private readonly oAuthService: OAuthService,
    private readonly authService: AuthService,
  ) {
    // Initialize observables AFTER DI is complete
    this.events$ = this.activityMonitorService.events.pipe(share());
    this.isOpen$ = this.events$.pipe(map(({ type }) => this.openTypes.includes(type)));
    this.remaining$ = this.events$.pipe(
      filter(({ type }) => type === 'tick'),
      map((event) => (event as TickEvent).remaining),
    );
  }

  ngOnInit(): void {
    this.logoutOnEndEvent();
    this.startActivityMonitorWhenAuthenticated();
  }

  private readonly logoutOnEndEvent = () => {
    this.events$
      .pipe(
        filter(({ type }) => type === 'end'),
        take(1),
      )
      .subscribe({
        next: () => {
          if (this.oAuthService.hasValidAccessToken()) {
            this.oAuthService.logOut();
          } else {
            this.oAuthService.initLoginFlow();
          }
        },
      });
  };

  private readonly startActivityMonitorWhenAuthenticated = () => {
    this.authService.isAuthenticated$.pipe(take(1)).subscribe({
      next: (loggedIn) => {
        if (loggedIn) {
          this.activityMonitorService.start();
        } else {
          this.activityMonitorService.stop();
        }
      },
    });
  };
}
